import type { CSSProperties, ReactNode } from "react";
import "./FlexContainer.css";

export const FlexContainer = ({
    border,
    borderBottom,
    children,
    color,
    alignItems,
    flex,
    flexDirection,
    flexWrap,
    gap,
    height,
    justifyContent,
    marginTop,
    marginBottom,
    maxWidth,
    minHeight,
    padding,
    width,
}: {
    border?: CSSProperties["border"];
    borderBottom?: CSSProperties["borderBottom"];
    children?: ReactNode;
    color?: CSSProperties["color"];
    alignItems?: CSSProperties["alignItems"];
    flex?: CSSProperties["flex"];
    flexDirection?: CSSProperties["flexDirection"];
    flexWrap?: CSSProperties["flexWrap"];
    gap?: CSSProperties["gap"];
    height?: CSSProperties["height"];
    justifyContent?: CSSProperties["justifyContent"];
    marginTop?: CSSProperties["marginTop"];
    marginBottom?: CSSProperties["marginBottom"];
    maxWidth?: CSSProperties["maxWidth"];
    minHeight?: CSSProperties["minHeight"];
    padding?: CSSProperties["padding"];
    width?: CSSProperties["width"];
}) => {
    return (
        <div
            className="flex-container"
            style={{
                border,
                borderBottom,
                color,
                alignItems,
                flex,
                flexDirection,
                flexWrap,
                gap,
                height,
                justifyContent,
                marginTop,
                marginBottom,
                maxWidth,
                minHeight,
                padding,
                width,
            }}
        >
            {children}
        </div>
    );
};
